import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["as", "branded", "children", "disabled", "onBlur", "onClick", "onFocus", "tabIndex"];
import '../../css-tokens';
import React, { forwardRef } from 'react';
import cx from 'classnames';
import Base from '../Base';
import system from '../../system';
import styles from './index.module.css';
var SYSTEM_PROPS = ['flexProps', 'marginProps', 'positioningProps', 'textProps', 'widthProps', 'floatProps'];

const LinkText = /*#__PURE__*/function () {
  const LinkText = /*#__PURE__*/forwardRef(function (_ref, ref) {
    var _classnames;

    var as = _ref.as,
        branded = _ref.branded,
        children = _ref.children,
        disabled = _ref.disabled,
        onBlur = _ref.onBlur,
        onClick = _ref.onClick,
        onFocus = _ref.onFocus,
        tabIndex = _ref.tabIndex,
        props = _objectWithoutPropertiesLoose(_ref, _excluded);

    var _system = system(props, SYSTEM_PROPS),
        className = _system[0],
        style = _system[1],
        rest = _system[2];

    var classnames = (_classnames = {}, _classnames[styles.root] = true, _classnames[styles.default] = !branded, _classnames[styles.branded] = branded, _classnames[styles.disabled] = disabled, _classnames);
    return /*#__PURE__*/React.createElement(Base, _extends({
      tabIndex: tabIndex,
      as: as,
      className: cx(classnames, className),
      disabled: disabled,
      onFocus: onFocus,
      onBlur: onBlur,
      onClick: onClick,
      ref: ref,
      style: style
    }, rest), children);
  });
  LinkText.displayName = 'LinkText';
  LinkText.identifier = LinkText.displayName; // used in docs website

  LinkText.clonableProps = SYSTEM_PROPS;
  LinkText.defaultProps = {
    as: 'a',
    branded: false,
    tabIndex: '0'
  };
  return LinkText;
}();

export default LinkText;